/* Ardor Banner Stand Designer: stand type and size (retractable, tabletop, X-stand, tension fabric and step and repeat
backdrops), 1 or 2 printed sides (same or different back), material, stand + graphic or graphic only, quantity, delivery,
live price, artwork on the stand's print template (rotate in 90 degree steps, zoom and pan), 3D preview, proof approval,
cart and quote. Ardor Printing. New Oct 12, 2026. Made from a copy of ardor-flag-builder.js (unchanged) by the patch list
stand/core/builder.patch. Loaded by sections/ardor-stand-builder-ws.liquid.
Oct 12, 2026 (tpl/flagfam/stand-builder.patch, patched in place; backup assets/ardor-stand-builder-backup-oct12tpl.js): a
finished template upload (the shape of the template page, within 1%) is placed edge to edge (tplFit); the add-to-cart
upload stays under the cart's 20 MB limit (fitUpload); tplInfo() names the stand for the template download
(assets/ardor-stand-tpl.js).
Every stand is drawn at true proportions from its print template (window.ArdorStandSpecs, assets/ardor-stand-specs.js):
the template page (what we print, bleed included), the visible area (what shows on the assembled stand), the hidden zones
(rolled into the base, under the top rail), the bleed and the safe line. The editor and the print files use the template
page in inches. Works with ardor-stand-layers.js (text and clipart), ardor-stand-ai.js (AI design), ardor-stand3d.js
(3D view) and ardor-stand-pdf.js (proof and print PDFs). */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!Array.isArray(CONF.variants)) CONF.variants = [];
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- banner stands, variants and prices ----------
  // One Shopify variant per stand, order type and material (product "Custom Banner Stands"). The section writes every
  // variant into the config: k = SKU ("BS-<KEY>-<KIT|GO>[-<material code>]", any letter case), o1 / o2 / o3 = option
  // values, id, c = price of ONE stand (or graphic) in cents, a = available. The cart line quantity = stands (or graphics).
  // KIT = the stand with its printed graphic; GO = the printed graphic only, for a stand the customer already has.
  // A 2-sided stand is its own key (<KEY>-2S). FALLBACK (window.ArdorStandSpecs.fallback, cents) is only used when the
  // config has no variants, so a price always shows; Add to cart then asks the customer to call.
  var SPECS = window.ArdorStandSpecs || {};
  var ST = SPECS.stands || {};
  var FALLBACK = SPECS.fallback || {};
  var FAMS = [
    { id: 'retractable', name: 'Retractable', sub: 'The graphic pulls up from its base', short: 'retractable banner stand' },
    { id: 'tabletop', name: 'Tabletop', sub: 'A small retractable for a table or counter', short: 'tabletop banner stand' },
    { id: 'x-stand', name: 'X-stand', sub: 'A banner held by an X frame', short: 'X-stand' },
    { id: 'fabric', name: 'Fabric & backdrop', sub: 'Tension fabric displays and step and repeat backdrops', short: 'fabric display' }
  ];
  var ORDERS = [
    { id: 'KIT', name: 'Stand + graphic', sub: 'The stand with your printed graphic', short: 'stand with graphic' },
    { id: 'GO', name: 'Graphic only', sub: 'A new graphic for a stand you already have', short: 'graphic only' }
  ];
  // LED light add-on (Oct 18 2026, Claude). Stands B2Sign sells with LED, Stand + graphic only. Prices, ids and availability
  // come from the Online Store product banner-stand-led-light (SKUs BS-LED-1, BS-LED-2, BS-LED-TF); if it is not
  // published the LED step stays hidden. Added to the cart as its own line after the stand.
  var LED_KEYS = { 'RS-23x66': 1, 'RS-24x81': 1, 'RS-33x81': 1, 'RS-33x81B': 1, 'RS-47x81': 2, 'RD-33x81': 1, 'RD-33x81-2S': 2, 'SD-36x69': 1, 'SD-36x80': 1, 'SD-36x92': 1, 'SD-48x69': 2, 'SD-48x80': 2, 'SD-48x92': 2, 'SD-60x69': 2, 'SD-60x80': 2, 'SD-60x92': 2, 'TF-36x90': 3, 'TF-36x90-2S': 3, 'TF-48x90': 3, 'TF-48x90-2S': 3 };
  var LED_V = { 1: { sku: 'BS-LED-1', name: '1 LED Light' }, 2: { sku: 'BS-LED-2', name: '2 LED Lights' }, 3: { sku: 'BS-LED-TF', name: '2 LED Lights' } };
  var LED_ON = false;
  function ledFor(c) { if (!LED_ON || !c || c.order !== 'KIT') return null; var t = LED_KEYS[c.key], v = t && LED_V[t]; return (v && v.id && v.ok && v.cents > 0) ? v : null; }
  function ledRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  try {
    fetch(ledRoot() + 'products/banner-stand-led-light.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (pr) {
        if (!pr || !pr.variants) return;
        pr.variants.forEach(function (v) { Object.keys(LED_V).forEach(function (k) { if (LED_V[k].sku === v.sku) { LED_V[k].id = v.id; LED_V[k].cents = Number(v.price) || 0; LED_V[k].ok = v.available !== false; } }); });
        LED_ON = true;
        try { render(); } catch (e) {}
      }).catch(function () {});
  } catch (e) {}
  function addLed(c) {
    if (!c || !c.led || !c.led.id) return Promise.resolve();
    return fetch(ledRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: c.led.id, quantity: c.qty, properties: { 'For': standLabel(c) + ', ' + sizeLabel(c) } }] }) })
      .then(function (r) { if (!r.ok) throw new Error('Your stand was added, but we couldn\'t add the LED light. Please add it again or request a quote.'); });
  }
  var MAX_QTY = 100;
  var SAFE = 1; // inches inside the visible area for the dashed red safe line when the template gives none
  var MAX_FILE = 25 * 1024 * 1024;
  var PICKUP = CONF.pickup || '12531 Old Snohomish Monroe Rd., Snohomish, WA 98290';
  var ORDER_KEYS = (SPECS.order || Object.keys(ST)).filter(function (k) { return ST[k] && ST[k].tpl && ST[k].visible; });

  var KEY_UC = {}; Object.keys(ST).forEach(function (k) { KEY_UC[k.toUpperCase()] = k; });
  // a stand key as written in the specs (sizes have a lowercase x: RS-33x81), any letter case accepted
  function normKey(s) { s = String(s || '').trim(); return ST[s] ? s : (KEY_UC[s.toUpperCase()] || ''); }
  function groupOf(fam) { return fam === 'retractable' || fam === 'retractable-sd' ? 'retractable' : (fam === 'tension' || fam === 'step-repeat' || fam === 'fabric' ? 'fabric' : (fam === 'tabletop' || fam === 'x-stand' ? fam : 'retractable')); }
  function famOf(id) { for (var i = 0; i < FAMS.length; i++) if (FAMS[i].id === id) return FAMS[i]; return FAMS[0]; }
  function orderOf(id) { for (var i = 0; i < ORDERS.length; i++) if (ORDERS[i].id === id) return ORDERS[i]; return ORDERS[0]; }
  function matCode(s) { return String(s == null ? '' : s).trim().toUpperCase(); }
  function baseOf(key) { return (ST[key] && ST[key].base) || String(key || '').replace(/-2S$/i, ''); }
  function facesOf(key) { return ST[key] && +ST[key].faces === 2 ? 2 : 1; }
  // the stand, order type and material of a variant: from its SKU (BS-<KEY>-<KIT|GO>[-<material>]), else from its options
  function parseSku(k) {
    var m = /^BS-(.+?)-(KIT|GO)(?:-(.+))?$/i.exec(String(k || '').trim());
    if (!m) return null;
    var key = normKey(m[1]);
    return key ? { key: key, order: m[2].toUpperCase(), mat: matCode(m[3]) } : null;
  }
  function fromOptions(v) {
    var o = [v.o1, v.o2, v.o3].map(function (x) { return String(x == null ? '' : x).trim(); }), key = '', order = 'KIT', mat = '';
    o.forEach(function (t) {
      var low = t.toLowerCase();
      if (!key) ORDER_KEYS.forEach(function (k) { if (!key && String(ST[k].name || '').toLowerCase() === low) key = k; });
      if (/graphic only|replacement/.test(low)) order = 'GO';
    });
    if (!key) return null;
    (ST[key].mats || []).forEach(function (m) { o.forEach(function (t) { if (!mat && t && String(m.name || '').toLowerCase() === t.toLowerCase()) mat = matCode(m.code); }); });
    return { key: key, order: order, mat: mat };
  }
  var VAR = {}, LIVE = false;
  CONF.variants.forEach(function (v) {
    if (!v) return;
    var p = parseSku(v.k) || fromOptions(v);
    if (!p) return;
    var cents = Math.round(Number(v.c));
    VAR[p.key + '|' + p.order + '|' + p.mat] = { id: v.id || null, cents: isFinite(cents) && cents > 0 ? cents : 0, available: v.a !== false, sku: String(v.k || '') };
    LIVE = true;
  });
  function fallbackCents(key, order, mat) {
    var f = FALLBACK[key], o = f && f[order];
    if (o == null) return 0;
    if (typeof o === 'number') return Math.round(o);
    var x = o[mat];
    if (x == null && !mat) for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) { x = o[k]; break; } }
    return Math.round(Number(x)) || 0;
  }
  // the variant for a stand, order type and material. none = the product has no such variant (not offered)
  function variantFor(key, order, mat) {
    var v = VAR[key + '|' + order + '|' + matCode(mat)];
    if (v) return v;
    if (LIVE) return { id: null, cents: 0, available: false, none: true };
    var x = fallbackCents(key, order, matCode(mat));
    return { id: null, cents: x, available: false, none: !x };
  }
  // the material codes of a stand ('' = its only material), for one order type or for any
  function matsFor(key, order) {
    var ms = ((ST[key] && ST[key].mats) || []).map(function (m) { return matCode(m.code); });
    if (LIVE) Object.keys(VAR).forEach(function (id) { var p = id.split('|'); if (p[0] === key && ms.indexOf(p[2]) < 0) ms.push(p[2]); });
    else if (FALLBACK[key]) ORDERS.forEach(function (o) { var f = FALLBACK[key][o.id]; if (f && typeof f === 'object') Object.keys(f).forEach(function (m) { if (ms.indexOf(m) < 0 && (m || !ms.length)) ms.push(m); }); });
    if (!ms.length) ms = [''];
    return ms.filter(function (m) { return order ? !variantFor(key, order, m).none : ORDERS.some(function (o) { return !variantFor(key, o.id, m).none; }); });
  }
  function ordersFor(key) { return ORDERS.filter(function (o) { return !(o.id === 'GO' && ST[key] && ST[key].goSameAs) && matsFor(key, o.id).length > 0; }); }
  function standsShown() { return ORDER_KEYS.filter(function (k) { return ordersFor(k).length > 0; }); }
  function famsShown() { var ks = standsShown(); return FAMS.filter(function (f) { return ks.some(function (k) { return groupOf(ST[k].fam) === f.id; }); }); }
  // the shown stands with the same model and size (1 side and 2 sides)
  function sideKeys(key) { var b = baseOf(key); return standsShown().filter(function (k) { return baseOf(k) === b; }); }
  function matName(key, code) {
    var s = ST[key] || {}, m = (s.mats || []).filter(function (x) { return matCode(x.code) === matCode(code); })[0];
    return m ? (m.name || m.code) : (code ? code.charAt(0) + code.slice(1).toLowerCase() : (s.material || ''));
  }
  function matSub(key, code) { var m = ((ST[key] && ST[key].mats) || []).filter(function (x) { return matCode(x.code) === matCode(code); })[0]; return (m && m.sub) || ''; }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  // ---------- print template geometry ----------
  // Inches from the template page's top-left (y down): the page (what we print, bleed included), the visible area (what
  // shows on the assembled stand), the hidden zones (rolled into the base, under the top rail), the bleed, the safe line
  // (SAFE in from the visible area unless the template says otherwise) and the grommets of X-stands. The back of a
  // 2-sided stand uses the same template unless the stand has its own back template.
  var GEO = {};
  function bbox(p) { var x0 = 1e9, y0 = 1e9, x1 = -1e9, y1 = -1e9; p.forEach(function (q) { x0 = Math.min(x0, q[0]); y0 = Math.min(y0, q[1]); x1 = Math.max(x1, q[0]); y1 = Math.max(y1, q[1]); }); return { x: x0, y: y0, w: x1 - x0, h: y1 - y0 }; }
  function R4(a) { return a && a.length === 4 && a.every(function (x) { return isFinite(+x); }) ? a.map(Number) : null; }
  function rectPts(r) { return [[r.x, r.y], [r.x + r.w, r.y], [r.x + r.w, r.y + r.h], [r.x, r.y + r.h]]; }
  function geoFor(key, back) {
    var id = key + '|' + (back ? 'b' : 'f');
    if (GEO[id]) return GEO[id];
    var s = ST[key] || {}, t = back && s.backTpl && s.backTpl.tpl ? s.backTpl : s, tp = t.tpl || {};
    var W = +(tp.w || tp[0]) || 33, H = +(tp.h || tp[1]) || 81, b = Math.max(0, +t.bleed || 0);
    var v = R4(t.visible) || [b, b, W - 2 * b, H - 2 * b];
    var sf = t.safe != null && isFinite(+t.safe) ? +t.safe : SAFE;
    var g = { W: W, H: H, bleed: b, safeIn: sf, name: s.name || key, tplName: t.tplName || s.tplName || '', placeholder: !!s.placeholder,
      vis: { x: v[0], y: v[1], w: v[2], h: v[3] },
      hidden: (t.hidden || []).map(function (z) { var r = R4(z && (z.rect || z)); return r ? { x: r[0], y: r[1], w: r[2], h: r[3], why: String((z && z.why) || '') } : null; }).filter(Boolean),
      grommets: (t.grommets || s.grommets || []).filter(function (q) { return q && isFinite(+q[0]) && isFinite(+q[1]); }).map(function (q) { return [+q[0], +q[1]]; }),
      trim: { x: b, y: b, w: W - 2 * b, h: H - 2 * b } };
    var sr = R4(t.safeRect);
    g.safeR = sr ? { x: sr[0], y: sr[1], w: sr[2], h: sr[3] } : { x: g.vis.x + sf, y: g.vis.y + sf, w: Math.max(1, g.vis.w - 2 * sf), h: Math.max(1, g.vis.h - 2 * sf) };
    // pole pockets (step and repeat): they show on the backdrop, but the pole runs inside, so text stays out of them
    g.pockets = (t.pockets || []).map(function (z) { var r = R4(z && (z.rect || z)); return r ? { x: r[0], y: r[1], w: r[2], h: r[3], why: String((z && z.why) || 'Pole pocket') } : null; }).filter(Boolean);
    var P = function (a) { return (a || []).filter(function (q) { return q && isFinite(+q[0]) && isFinite(+q[1]); }).map(function (q) { return [+q[0], +q[1]]; }); };
    var cp = P(t.cutPoly), sp = P(t.safePoly);
    // the cut line: the template's own outline when it has one (tension fabric: chamfered top corners), else the trim box
    g.cut = cp.length > 2 ? cp : rectPts(g.trim); g.cutPoly = cp.length > 2;
    g.safe = [sp.length > 2 ? sp : rectPts(g.safeR)];
    g.face = [g.vis.x, g.vis.y, g.vis.x + g.vis.w, g.vis.y + g.vis.h];
    g.bx = g.vis.x; g.by = g.vis.y; g.bw = g.vis.w; g.bh = g.vis.h;
    return (GEO[id] = g);
  }
  // the face being shown or printed: the front, or the back of a 2-sided stand (as seen from the back)
  function faceGeo(c, face) { return geoFor(c.key, (face === 'back' || face === 'back-flat') && c.sides === 2); }

  var S = { key: '', order: 'KIT', mat: '', qty: 1, delivery: 'ship', back: false, backMode: 'same', face: 'front', artVer: 0 };
  var ART = { front: null, back: null };
  var eng = null;
  (function () {
    var ks = standsShown(), want = normKey(CONF.defaultStand) || 'RS-33x81';
    S.key = ks.indexOf(want) >= 0 ? want : (ks[0] || ORDER_KEYS[0] || '');
  })();

  // c.Wi x c.Hi = the template page of the stand in inches (art covers all of it, bleed and hidden zones included).
  // c.qty = stands (or graphics, for graphic only).
  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var shown = standsShown();
    var key = ST[s.key] && shown.indexOf(s.key) >= 0 ? s.key : (shown[0] || ORDER_KEYS[0]);
    var st = ST[key] || {};
    var ords = ordersFor(key), ord = ords.filter(function (o) { return o.id === s.order; })[0] || ords[0] || ORDERS[0];
    var mats = matsFor(key, ord.id), want = matCode(s.mat), mat = mats.indexOf(want) >= 0 ? want : (mats[0] || '');
    var qty = Math.max(1, Math.min(MAX_QTY, Math.round(Number(s.qty)) || 1));
    var c = { key: key, st: st, fam: famOf(groupOf(st.fam)), famId: st.fam || 'retractable', base: baseOf(key), sides: facesOf(key), order: ord.id, orderObj: ord, orders: ords,
      mat: mat, mats: mats, qty: qty, delivery: s.delivery === 'pickup' ? 'pickup' : 'ship', v: variantFor(key, ord.id, mat), artVer: s.artVer };
    c.ledOpt = ledFor(c); c.led = (s.led && c.ledOpt) ? c.ledOpt : null;
    c.geo = faceGeo(c, 'front'); c.Wi = c.geo.W; c.Hi = c.geo.H;
    return c;
  }
  // each = one stand (or graphic); charged = what goes in the cart
  function price(c) {
    var each = c.v.cents / 100 + (c.led ? c.led.cents / 100 : 0);
    return { each: each, charged: each * c.qty, unit: each, vid: c.v.id, disc: 0, led: c.led ? c.led.cents / 100 : 0 };
  }
  // the lowest price a stand can be ordered for (with this order type when given)
  function fromCents(key, order) {
    var lo = 0;
    ORDERS.forEach(function (o) { if (order && o.id !== order) return; matsFor(key, o.id).forEach(function (m) { var v = variantFor(key, o.id, m); if (!v.none && v.cents > 0 && (!lo || v.cents < lo)) lo = v.cents; }); });
    return lo;
  }
  function baseFrom(key, order) { var lo = 0; sideKeys(key).forEach(function (k) { var x = fromCents(k, order) || fromCents(k); if (x > 0 && (!lo || x < lo)) lo = x; }); return lo; }
  function groupFrom(gid) { var lo = 0; standsShown().forEach(function (k) { if (groupOf(ST[k].fam) !== gid) return; var x = fromCents(k); if (x > 0 && (!lo || x < lo)) lo = x; }); return lo; }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
  function inchTxt(n) { return fmt(Math.round(n * 4) / 4); }
  function sizeName(key) { var s = ST[key]; return (s && s.szName) || key; }
  function sizeSub(key) { var s = ST[key]; return (s && s.szSub) || ''; }
  function standLabel(c) { return c.st.stand || c.fam.name; }
  function visTxt(g) { return inchTxt(g.vis.w) + ' x ' + inchTxt(g.vis.h) + ' in'; }
  function tplTxt(c) { return fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in'; }
  function sizeLabel(c) { return sizeName(c.key) + ' (visible graphic ' + visTxt(c.geo) + ', width x height)'; }
  function sizeChip(c) { return sizeName(c.key) + (c.fam.id === 'fabric' || c.fam.id === 'x-stand' ? '' : ' ' + c.fam.short); }
  function sidesLabel(c) { return c.sides === 2 ? '2 sides (front and back)' : '1 side'; }
  function orderLabel(c) { return c.orderObj.name; }
  function matLabel(c) { return matName(c.key, c.mat); }
  function qtyNoun(c, n) { return c.order === 'GO' ? (n === 1 ? 'graphic' : 'graphics') : (n === 1 ? 'stand' : 'stands'); }
  function qtyLabel(n, c) { return n + ' ' + qtyNoun(c || cfg(), n); }
  function deliveryLabel(c) { return c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Ship to me (free)'; }
  function frontLabel(c) { return c.sides === 2 && S.backMode !== 'different' ? 'Front (same art on the back)' : 'Front'; }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  // a new stand: keep the art, but fit it to the new template (Fill for pictures, Fit for files), and show the whole page
  function resetArt() { [ART.front, ART.back].forEach(function (a) { if (a) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; } }); }
  function pickStand(key) {
    key = normKey(key);
    if (!key || key === S.key) return;
    var same = ST[S.key] && ST[key] && +ST[S.key].tpl.w === +ST[key].tpl.w && +ST[S.key].tpl.h === +ST[key].tpl.h;
    if (!same) { resetArt(); lay.zoom = 1; lay.cx = 0.5; lay.cy = 0.5; }
    var patch = { key: key, artVer: S.artVer + 1 };
    if (facesOf(key) !== 2) { patch.face = 'front'; patch.back = false; }
    set(patch);
    if (facesOf(key) !== 2) view3d('front');
  }
  // a new stand type: its usual stand
  function pickFamily(gid) {
    var c = cfg(); if (c.fam.id === gid) return;
    var ks = standsShown().filter(function (k) { return groupOf(ST[k].fam) === gid; }); if (!ks.length) return;
    var dflt = SPECS.famDefault && ks.indexOf(SPECS.famDefault[gid]) >= 0 ? SPECS.famDefault[gid] : ks[0];
    pickStand(dflt);
  }
  // a new model and size of the same type: keep the sides when that size has them
  function pickSize(key) {
    var c = cfg(), ks = sideKeys(key); if (!ks.length) return;
    pickStand(ks.filter(function (k) { return facesOf(k) === c.sides; })[0] || ks[0]);
  }
  // 1 side or 2 sides: the same model and size printed on one face or on both
  function pickSides(n) {
    var c = cfg(); if (n === c.sides) return;
    var k = sideKeys(c.key).filter(function (x) { return facesOf(x) === n; })[0]; if (!k) return;
    pickStand(k);
  }
  function pickOrder(id) { if (id !== S.order) set({ order: id }); }
  function pickMat(code) { if (matCode(code) !== matCode(S.mat)) set({ mat: matCode(code) }); }
  function setQty(n) { n = Math.max(1, Math.min(MAX_QTY, Math.round(Number(n)) || 1)); if (n !== S.qty) set({ qty: n }); else render(); }
  // the back of a 2-sided stand: the same art as the front, or its own
  function pickBackMode(mode) {
    if (mode === S.backMode) return;
    var patch = { backMode: mode, artVer: S.artVer + 1 };
    if (mode === 'different') { patch.face = 'back'; patch.back = true; } // go straight to the back so its art can be added
    else { patch.face = 'front'; patch.back = false; }
    set(patch);
    view3d(S.back ? 'back' : 'front');
  }

  // ---------- artwork ----------
  function artFor(face) {
    if (face === 'back' || face === 'back-flat') {
      var c = cfg();
      if (c.sides === 2 && S.backMode === 'different') return ART.back;
      return ART.front;
    }
    return ART.front;
  }
  // v2: text, clipart and logo layers added in the builder (ardor-stand-layers.js). Same face rule as artFor.
  function layerFace(face) { return (face === 'back' || face === 'back-flat') && cfg().sides === 2 && S.backMode === 'different' ? 'back' : 'front'; }
  function hasLayers(f) { return !!(window.ArdorStandLayers && window.ArdorStandLayers.has(f)); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  // Oct 12, 2026 (tpl): the cart refuses any add-to-cart request over 20 MB ("413 Request Entity Too Large"), and the
  // request holds the proof, the print file(s) and the customer's original upload(s). Keep the whole upload under
  // UPLOAD_BUDGET: print files first (made smaller when needed), then the proof, then the original files while they fit.
  // Same approach as assets/ardor-aframe-builder-v2-v2.js.
  var UPLOAD_BUDGET = 18 * 1024 * 1024;
  function fmtMB(n) { return (n / 1048576).toFixed(1) + ' MB'; }
  function decodeBlob(file) {
    if (window.createImageBitmap) return createImageBitmap(file);
    return new Promise(function (res, rej) {
      var u = URL.createObjectURL(file), im = new Image();
      im.onload = function () { res(im); };
      im.onerror = function () { URL.revokeObjectURL(u); rej(new Error('could not read the print image')); };
      im.src = u;
    });
  }
  // re-encode a JPEG/PNG smaller (fewer pixels, then lower quality) until it is at most maxBytes
  function shrinkImage(file, maxBytes) {
    if (!file || file.size <= maxBytes) return Promise.resolve(file);
    return decodeBlob(file).then(function (bmp) {
      var bw = bmp.naturalWidth || bmp.width, bh = bmp.naturalHeight || bmp.height;
      var scale = Math.min(1, Math.sqrt(maxBytes / file.size) * 0.95), q = 0.9, tries = 0;
      var attempt = function () {
        var w = Math.max(1, Math.round(bw * scale)), h = Math.max(1, Math.round(bh * scale));
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
        var ctx = cv.getContext('2d');
        if (!ctx) return Promise.reject(new Error('canvas'));
        ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, w, h);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(bmp, 0, 0, w, h);
        return new Promise(function (res) { cv.toBlob(res, 'image/jpeg', q); }).then(function (b) {
          cv.width = cv.height = 1;
          if (!b) throw new Error('could not make the print image');
          if (b.size > maxBytes && tries < 5) { tries++; scale *= Math.sqrt(maxBytes / b.size) * 0.95; q = Math.max(0.8, q - 0.03); return attempt(); }
          if (bmp.close) bmp.close();
          return new File([b], String(file.name || 'Ardor Banner Stand Print Art').replace(/\.[A-Za-z0-9]{1,5}$/, '') + '.jpg', { type: 'image/jpeg' });
        });
      };
      return attempt();
    });
  }
  // the print file for one face again, as one flattened image of at most maxBytes (same path as faces with text or clipart)
  function smallerPrint(c, face, a, maxBytes, approval) {
    var P = window.ArdorStandPDF, LY = window.ArdorStandLayers, Wi = c.Wi, Hi = c.Hi;
    if (!P || !P.buildPrint || !LY || !LY.composite) return Promise.reject(new Error('print tools not loaded'));
    var stamp = (approval && approval.when) || stampLabel(new Date());
    return LY.composite(face, Wi, Hi, a).then(function (r) { return shrinkImage(r.file, maxBytes - 65536); }).then(function (file) {
      return P.buildPrint({ title: 'Ardor Banner Stand Print File', stamp: stamp, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125,
        faces: [{ art: { file: file, name: file.name, kind: 'image', bg: '#FFFFFF' }, bg: '#FFFFFF', geomFor: function () { return { x: 0, y: 0, w: Wi, h: Hi }; } }] }, false);
    }).then(function (r) { return r && r.blob; });
  }
  function fitUpload(c, files, approval) {
    var backDiff = c.sides === 2 && S.backMode === 'different';
    var faces = backDiff ? ['front', 'back'] : ['front'];
    var size = function (b) { return b ? b.size : 0; };
    files.skipArt = { front: false, back: false }; files.needEmail = false;
    var orig = function (f) { return ART[f] && ART[f].file ? ART[f].file : null; };
    var prints = function () { return faces.reduce(function (t, f) { return t + size(files[f]); }, 0); };
    var total = function () { return size(files.proof) + prints() + faces.reduce(function (t, f) { return t + (files.skipArt[f] ? 0 : size(orig(f))); }, 0); };
    if (total() <= UPLOAD_BUDGET) return Promise.resolve(files);
    // 1. each print file gets an equal share of what the proof leaves
    var share = Math.max(1572864, Math.floor((UPLOAD_BUDGET - size(files.proof) - 262144) / faces.length));
    var chain = Promise.resolve();
    faces.forEach(function (f) {
      chain = chain.then(function () {
        var bl = files[f]; if (!bl || bl.size <= share) return null;
        return smallerPrint(c, f, ART[f], share, approval).then(function (nb) {
          if (nb && nb.size < bl.size) {
            files[f] = nb;
            files.notes.push('The ' + f + ' print file was made at a lower resolution (' + fmtMB(bl.size) + ' to ' + fmtMB(nb.size) + ') to fit the 20 MB online order upload limit.');
          }
        }, function () { return null; });
      });
    });
    return chain.then(function () {
      // 2. the customer's original files, while they still fit
      var used = size(files.proof) + prints();
      faces.forEach(function (f) {
        var o = orig(f); if (!o) return;
        if (used + o.size <= UPLOAD_BUDGET) { used += o.size; return; }
        files.skipArt[f] = true;
        if (!files[f]) files.needEmail = true;
        files.notes.push('The customer\'s original ' + f + ' file (' + (ART[f].name || 'artwork') + ', ' + fmtMB(o.size) + ') was not attached (over the 20 MB online order upload limit).' + (files[f] ? ' The print file has the full design.' : ' The customer was asked to email it.'));
      });
      // 3. last resort: a print file that could not be made small enough stays out
      ['back', 'front'].forEach(function (f) {
        if (total() <= UPLOAD_BUDGET || !files[f]) return;
        files.notes.push('The ' + f + ' print file (' + fmtMB(files[f].size) + ') was too large to attach. Make it from the original artwork.');
        files[f] = null;
        if (files.skipArt[f] || !orig(f)) files.needEmail = true;
      });
      return files;
    });
  }
  // print job for one sign: with text or clipart, the face is one flattened image (artwork + layers) at the exact sign size
  function layerJob(mkJob, a, f, Wi, Hi, notes) {
    if (!hasLayers(f)) return Promise.resolve(mkJob(a));
    return window.ArdorStandLayers.composite(f, Wi, Hi, a).then(function (r) {
      var job = mkJob({ file: r.file, name: r.file.name, kind: 'image', bg: '#FFFFFF' });
      job.faces[0].geomFor = function () { return { x: 0, y: 0, w: Wi, h: Hi }; };
      if (notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      return job;
    });
  }
  function layerSummary(c) {
    var LY = window.ArdorStandLayers; if (!LY || !LY.list) return '';
    var keys = c.sides === 2 && S.backMode === 'different' ? ['front', 'back'] : ['front'];
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? (keys.length > 1 ? (k === 'front' ? 'Front: ' : 'Back: ') : '') + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  // art turned 90 or 270 degrees: its box is as wide as the picture is tall
  function rot90(a) { return !!a && (a.rot === 90 || a.rot === 270); }
  function geom(a, Wi, Hi) {
    var ia = rot90(a) ? a.natH / a.natW : a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW, rot: a.rot || 0 };
  }
  // draw a picture into its placed box g (the box of the art as turned), turned g.rot degrees clockwise
  function drawRot(ctx, img, g) {
    if (!g.rot) { ctx.drawImage(img, g.x, g.y, g.w, g.h); return; }
    var q = g.rot === 90 || g.rot === 270, dw = q ? g.h : g.w, dh = q ? g.w : g.h;
    ctx.save();
    ctx.translate(g.x + g.w / 2, g.y + g.h / 2);
    ctx.rotate(g.rot * Math.PI / 180);
    ctx.drawImage(img, -dw / 2, -dh / 2, dw, dh);
    ctx.restore();
  }

  function paintFace(ctx, Wi, Hi, face) {
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v2: no artwork, but text or clipart: white sign with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorStandLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      drawRot(ctx, a.img, g);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.min(Hi * 0.12, Wi * 0.07);
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.52);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorStandLayers.paint(ctx, Wi, Hi, lf); // v2
    return true;
  }

  // Phone photos are often stored sideways with a "turn me" tag. Browsers follow the tag, but a JPEG placed in a PDF
  // as it is does not, so those photos get an upright copy for the print file. The customer's own file is still
  // attached to the order.
  var ROT_NOTE = 'A photo carried a camera rotation tag, so the print file uses an upright copy of it.';
  function jpegOrientation(file) {
    return file.slice(0, 262144).arrayBuffer().then(function (ab) {
      var v = new DataView(ab), n = v.byteLength, p = 2;
      if (n < 4 || v.getUint16(0) !== 0xFFD8) return 1;
      while (p + 4 <= n) {
        var m = v.getUint16(p);
        if ((m & 0xFF00) !== 0xFF00) return 1;
        if (m === 0xFFDA || m === 0xFFD9) return 1;
        var len = v.getUint16(p + 2);
        if (m === 0xFFE1 && p + 18 <= n && v.getUint32(p + 4) === 0x45786966) {
          var t = p + 10, le = v.getUint16(t) === 0x4949;
          var ifd = t + v.getUint32(t + 4, le);
          if (ifd + 2 > n) return 1;
          var cnt = v.getUint16(ifd, le);
          for (var i = 0; i < cnt; i++) {
            var e = ifd + 2 + i * 12;
            if (e + 12 > n) return 1;
            if (v.getUint16(e, le) === 0x0112) return v.getUint16(e + 8, le) || 1;
          }
          return 1;
        }
        p += 2 + len;
      }
      return 1;
    }).catch(function () { return 1; });
  }
  function fixOrientation(a) {
    if (!/jpe?g/i.test(a.file.type || '') && !/\.jpe?g$/i.test(a.name)) return;
    a.ready = jpegOrientation(a.file).then(function (o) {
      if (!(o >= 2 && o <= 8) || !a.img) return null;
      var k = Math.min(1, Math.sqrt(40e6 / (a.natW * a.natH)));
      var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round(a.natW * k)); cv.height = Math.max(1, Math.round(a.natH * k));
      cv.getContext('2d').drawImage(a.img, 0, 0, cv.width, cv.height);
      return new Promise(function (res) {
        cv.toBlob(function (b) {
          if (b) { a.printFile = new File([b], 'Ardor Banner Stand Print Art.jpg', { type: 'image/jpeg' }); a.rotated = o; }
          cv.width = cv.height = 1; res(null);
        }, 'image/jpeg', 0.95);
      });
    }).catch(function () {});
  }

  // A file added while the Back tab shows "Same on both sides" is art for the back, so the sign switches to "Different back".
  function uploadFace(file) {
    if (S.face !== 'back') return 'front';
    if (file && file.size <= MAX_FILE && cfg().sides === 2 && S.backMode !== 'different') {
      S.backMode = 'different'; S.back = true; S.artVer++;
      toast('This art goes on the back. The front keeps its own art.');
    }
    return 'back';
  }

  // Oct 12 (tpl): a finished template file (made on the template page of this face, so it has the page's shape within TPL_TOL)
  // is placed edge to edge on the whole page, bleed included, unturned
  var TPL_TOL = 0.01;
  function tplFit(a, face) {
    var c = cfg();
    if (!a || !a.img || !(a.natW > 0) || !(a.natH > 0) || !(c.Wi > 0) || !(c.Hi > 0)) return false;
    if (Math.abs((a.natW / a.natH) / (c.Wi / c.Hi) - 1) > TPL_TOL) return false;
    a.mode = 'fill'; a.rot = 0; a.rcx = 0.5; a.rcy = 0.5; a.tpl = true;
    toast('Template file detected - placed edge to edge');
    return true;
  }
  function loadFile(file, face) {
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF', rot: 0 };
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500; fixOrientation(a);
      ART[face] = a; tplFit(a, face); S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      if (ART.front === a || ART.back === a) { tplFit(a, ART.front === a ? 'front' : 'back'); S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your banner stand, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your banner stand.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your banner stand.' + tail;
  }
  function needsEmailProof() {
    var c = cfg(), used = [ART.front]; if (c.sides === 2 && S.backMode === 'different') used.push(ART.back);
    return used.some(function (x) { return x && x.noPreview; });
  }

  // ---------- flat stand drawing (2D editor, 3D faces and proof) ----------
  function polyPath(ctx, p) { if (!p || !p.length) return; ctx.moveTo(p[0][0], p[0][1]); for (var i = 1; i < p.length; i++) ctx.lineTo(p[i][0], p[i][1]); ctx.closePath(); }
  var checkerCv = null;
  function checker(ctx, u) {
    try {
      if (!checkerCv) {
        checkerCv = document.createElement('canvas'); checkerCv.width = checkerCv.height = 16;
        var x = checkerCv.getContext('2d'); x.fillStyle = '#ECECEF'; x.fillRect(0, 0, 16, 16); x.fillStyle = '#DADADF'; x.fillRect(0, 0, 8, 8); x.fillRect(8, 8, 8, 8);
      }
      var pat = ctx.createPattern(checkerCv, 'repeat');
      if (pat && pat.setTransform && window.DOMMatrix) { pat.setTransform(new DOMMatrix().scale(u * 0.75)); return pat; }
    } catch (e) {}
    return '#E6E6EA';
  }
  // a label centered in a box, at least about 9 screen pixels high, shrunk to fit the box's width
  function zoneLabel(ctx, txt, x, y, w, h, u) {
    if (!txt) return;
    var turn = h > w * 2.5, L = turn ? h : w, T = turn ? w : h;
    if (T / u < 6) return; // thinner than 6 screen pixels: no room for a label
    ctx.save();
    ctx.font = '700 1px Arial, sans-serif';
    var tw = ctx.measureText(txt).width || txt.length * 0.6;
    var fs = Math.max(Math.min(T * 0.5, (L * 0.86) / tw, 3), u * 9);
    if (tw * fs > L * 0.98) fs = (L * 0.98) / tw;
    if (fs / u < 6) { ctx.restore(); return; }
    ctx.translate(x + w / 2, y + h / 2); if (turn) ctx.rotate(-Math.PI / 2);
    ctx.font = '700 ' + fs + 'px Arial, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.lineJoin = 'round'; ctx.lineWidth = fs * 0.28; ctx.strokeStyle = 'rgba(30,31,36,0.85)'; ctx.strokeText(txt, 0, 0);
    ctx.fillStyle = 'rgba(255,255,255,0.96)'; ctx.fillText(txt, 0, 0);
    ctx.restore();
  }
  // the guides on one face: outside the visible area dimmed (it does not show on the stand), the hidden zones greyed and
  // labelled (rolled into the base, under the top rail), the bleed edge, the visible area's edge, the grommets of
  // X-stands and the dashed red safe line. u = inches per screen pixel (line widths).
  function drawGuides(ctx, c, Wi, Hi, face, u) {
    var G = faceGeo(c, face), v = G.vis;
    ctx.save();
    ctx.setLineDash([]);
    ctx.beginPath(); ctx.rect(0, 0, Wi, Hi); ctx.rect(v.x, v.y, v.w, v.h);
    ctx.globalAlpha = 0.55; ctx.fillStyle = checker(ctx, u); ctx.fill('evenodd'); ctx.globalAlpha = 1;
    var said = {};
    G.hidden.forEach(function (z) {
      ctx.fillStyle = 'rgba(52,54,62,0.62)'; ctx.fillRect(z.x, z.y, z.w, z.h);
      ctx.beginPath(); ctx.moveTo(z.x, z.y); ctx.lineTo(z.x + z.w, z.y); ctx.moveTo(z.x, z.y + z.h); ctx.lineTo(z.x + z.w, z.y + z.h);
      ctx.lineWidth = u; ctx.strokeStyle = 'rgba(255,255,255,0.45)'; ctx.stroke();
    });
    // one label per kind of zone, on its biggest zone
    G.hidden.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; }).forEach(function (z) {
      var t = String(z.why || 'Hidden').toUpperCase(); if (said[t]) return; said[t] = 1;
      zoneLabel(ctx, t, z.x, z.y, z.w, z.h, u);
    });
    if (G.cutPoly) {
      // outside the template outline is cut off
      ctx.beginPath(); ctx.rect(-Wi, -Hi, 3 * Wi, 3 * Hi); polyPath(ctx, G.cut);
      ctx.fillStyle = checker(ctx, u); ctx.fill('evenodd');
      ctx.beginPath(); polyPath(ctx, G.cut); ctx.lineWidth = u * 1.4; ctx.strokeStyle = 'rgba(12,13,13,0.9)'; ctx.stroke();
    }
    G.pockets.forEach(function (z) {
      ctx.save(); ctx.beginPath(); ctx.rect(z.x, z.y, z.w, z.h); ctx.clip();
      ctx.fillStyle = 'rgba(52,54,62,0.18)'; ctx.fillRect(z.x, z.y, z.w, z.h);
      ctx.beginPath(); var st = Math.max(u * 10, 0.6);
      for (var hx = z.x - z.h; hx < z.x + z.w; hx += st) { ctx.moveTo(hx, z.y + z.h); ctx.lineTo(hx + z.h, z.y); }
      ctx.lineWidth = u; ctx.strokeStyle = 'rgba(52,54,62,0.35)'; ctx.stroke(); ctx.restore();
      zoneLabel(ctx, String(z.why || 'Pole pocket').toUpperCase(), z.x, z.y, z.w, z.h, u);
    });
    if (G.bleed > 0) {
      // the bleed: the part outside the trim line is cut off
      ctx.beginPath(); ctx.rect(G.trim.x, G.trim.y, G.trim.w, G.trim.h);
      ctx.setLineDash([u * 3, u * 3]); ctx.lineWidth = u * 1.2; ctx.strokeStyle = 'rgba(12,13,13,0.75)'; ctx.stroke(); ctx.setLineDash([]);
    }
    ctx.save();
    if (G.cutPoly) { ctx.beginPath(); polyPath(ctx, G.cut); ctx.clip(); } // the visible area's edge stops at the outline
    ctx.beginPath(); ctx.rect(v.x, v.y, v.w, v.h);
    ctx.lineWidth = u * 1.4; ctx.strokeStyle = 'rgba(12,13,13,0.9)'; ctx.stroke();
    ctx.restore();
    G.grommets.forEach(function (q) {
      var r = Math.max(0.3, u * 4);
      ctx.beginPath(); ctx.arc(q[0], q[1], r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255,255,255,0.9)'; ctx.fill();
      ctx.lineWidth = Math.max(u * 1.6, r * 0.45); ctx.strokeStyle = 'rgba(70,72,80,0.95)'; ctx.stroke();
    });
    G.safe.forEach(function (p) {
      ctx.beginPath(); polyPath(ctx, p);
      ctx.setLineDash([]); ctx.lineWidth = u * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)'; ctx.stroke();
      ctx.setLineDash([u * 6, u * 4]); ctx.lineWidth = u * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)'; ctx.stroke();
    });
    ctx.setLineDash([]);
    ctx.restore();
  }
  function drawFlat(ctx, c, Wi, Hi, face, guides, u) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, face), tall = G.bh > G.bw * 1.6;
      ctx.save();
      ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2);
      if (tall) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork goes here', 0, 0);
      ctx.restore();
    }
    if (!guides) return;
    drawGuides(ctx, c, Wi, Hi, face, u || Math.max(Wi, Hi) / 600);
  }

  // ---------- flat layout editor: the whole template fits the stage; zoom in and pan to work on part of it ----------
  // lay.scale = screen px per inch, lay.ox / lay.oy = where the page's top-left corner sits on the canvas (css px),
  // lay.zoom 1 = whole page, lay.cx / lay.cy = the view's center in page fractions when zoomed in.
  var lay = { canvas: null, scale: 1, drag: false, pan: false, hand: false, lx: 0, ly: 0, zoom: 1, cx: 0.5, cy: 0.5, ox: 0, oy: 0 };
  var ZMAX = 8;
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 520;
    var fit = Math.min(maxW / Wi, maxH / Hi), z = fit * lay.zoom;
    var cssW = Math.max(1, Math.round(Math.min(Wi * z, maxW))), cssH = Math.max(1, Math.round(Math.min(Hi * z, maxH)));
    var hx = cssW / (2 * z * Wi), hy = cssH / (2 * z * Hi);
    lay.cx = hx >= 0.5 ? 0.5 : clamp(lay.cx, hx, 1 - hx);
    lay.cy = hy >= 0.5 ? 0.5 : clamp(lay.cy, hy, 1 - hy);
    lay.ox = cssW / 2 - lay.cx * Wi * z; lay.oy = cssH / 2 - lay.cy * Hi * z;
    lay.scale = z; lay.fit = fit;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = cssW + 'px'; cv.style.height = cssH + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    var kx = cv.width / cssW, ky = cv.height / cssH;
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.setTransform(z * kx, 0, 0, z * ky, lay.ox * kx, lay.oy * ky);
    drawFlat(ctx, c, Wi, Hi, S.face === 'back' ? 'back-flat' : 'front', true, 1 / z);
    syncZoomUi();
    try { root.dispatchEvent(new CustomEvent('ardor:stand-view')); } catch (e) {}
  }
  function syncZoomUi() {
    var out = $('[data-abb-zoom2d-val]'); if (out) out.textContent = Math.round(lay.zoom * 100) + '%';
    var zi = $('[data-abb-zoom2d-in]'), zo = $('[data-abb-zoom2d-out]'), zf = $('[data-abb-zoom2d-fit]'), hb = $('[data-abb-hand]');
    var zoomed = lay.zoom > 1.001;
    if (!zoomed) lay.hand = false;
    if (zi) zi.disabled = lay.zoom >= ZMAX - 0.001;
    if (zo) zo.disabled = !zoomed;
    if (zf) zf.disabled = !zoomed;
    if (hb) { hb.hidden = !zoomed; hb.setAttribute('aria-pressed', lay.hand ? 'true' : 'false'); }
    if (lay.canvas) lay.canvas.style.cursor = lay.hand ? 'grab' : '';
    root.classList.toggle('abb--hand', !!lay.hand);
  }
  // zoom to z (1 = whole page); (px, py) = the canvas point (css px) that stays put, else the view's center
  function setZoom(z, px, py) {
    var c = cfg(), Z = clamp(z, 1, ZMAX);
    if (px != null && lay.scale > 0) {
      var ux = (px - lay.ox) / lay.scale / c.Wi, uy = (py - lay.oy) / lay.scale / c.Hi, z1 = lay.fit * Z;
      var cw = lay.canvas ? parseFloat(lay.canvas.style.width) || 0 : 0, ch = lay.canvas ? parseFloat(lay.canvas.style.height) || 0 : 0;
      lay.cx = ux + (cw / 2 - px) / (z1 * c.Wi); lay.cy = uy + (ch / 2 - py) / (z1 * c.Hi);
    }
    lay.zoom = Z;
    drawLayout();
  }
  function panBy(dx, dy) { var c = cfg(); lay.cx -= dx / (lay.scale * c.Wi); lay.cy -= dy / (lay.scale * c.Hi); drawLayout(); }
  // turn the art on the face being edited 90 degrees (d = 90 right, -90 left) around its center, keeping its size
  function rotateArt(d) {
    var a = editingArt(); if (!a || !a.img) return;
    var c = cfg(), g = geom(a, c.Wi, c.Hi);
    a.rot = (((a.rot || 0) + d) % 360 + 360) % 360;
    if (a.mode === 'custom') a.rw = g.h / c.Wi;
    S.artVer++; render();
  }

  function editingArt() { return S.face === 'back' ? (S.backMode === 'different' ? ART.back : null) : ART.front; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    // drag the art to move it. Zoomed in: drag outside the art (or with the hand tool on) to move the view.
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(), c = cfg(), zoomed = lay.zoom > 1.001, onArt = false;
      if (a && a.img && !lay.hand) {
        if (!zoomed) onArt = true;
        else {
          var g = geom(a, c.Wi, c.Hi), r = cv.getBoundingClientRect();
          var ux = (e.clientX - r.left - lay.ox) / lay.scale, uy = (e.clientY - r.top - lay.oy) / lay.scale;
          onArt = ux >= g.x && ux <= g.x + g.w && uy >= g.y && uy <= g.y + g.h;
        }
      }
      if (!onArt && !zoomed) return;
      lay.drag = onArt; lay.pan = !onArt; lay.lx = e.clientX; lay.ly = e.clientY;
      if (lay.pan) cv.style.cursor = 'grabbing';
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (lay.pan) { var px = e.clientX - lay.lx, py = e.clientY - lay.ly; lay.lx = e.clientX; lay.ly = e.clientY; panBy(px, py); return; }
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { var was = lay.pan; lay.drag = false; lay.pan = false; if (was) syncZoomUi(); };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    // mouse wheel / trackpad over the stage: pinch or Ctrl + wheel zooms, the wheel moves the view when zoomed in
    cv.parentNode.addEventListener('wheel', function (e) {
      var r = cv.getBoundingClientRect(), px = e.clientX - r.left, py = e.clientY - r.top;
      if (e.ctrlKey || e.metaKey) { e.preventDefault(); setZoom(lay.zoom * Math.pow(0.996, e.deltaY), px, py); return; }
      if (lay.zoom <= 1.001) return;
      e.preventDefault();
      panBy(-(e.shiftKey ? e.deltaY : e.deltaX), -(e.shiftKey ? 0 : e.deltaY));
    }, { passive: false });
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; S.artVer++; renderArtOnly(); } });
    on('[data-abb-rot-l]', 'click', function () { rotateArt(-90); });
    on('[data-abb-rot-r]', 'click', function () { rotateArt(90); });
    on('[data-abb-zoom2d-in]', 'click', function () { setZoom(lay.zoom * 1.5); });
    on('[data-abb-zoom2d-out]', 'click', function () { setZoom(lay.zoom / 1.5); });
    on('[data-abb-zoom2d-fit]', 'click', function () { lay.cx = 0.5; lay.cy = 0.5; setZoom(1); });
    on('[data-abb-hand]', 'click', function () { lay.hand = !lay.hand; syncZoomUi(); });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  // resolution check: under 40 pixels per inch prints blurry (red), under 75 looks soft up close (amber)
  function resIssue(a, c) {
    if (!a || !a.img || a.kind !== 'image' || /svg/i.test(a.file.type || a.name)) return null;
    var g = geom(a, c.Wi, c.Hi), ppi = Math.round(a.natW / (rot90(a) ? g.h : g.w));
    if (ppi < 40) return { level: 'bad', text: ' is only about ' + ppi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF, or pick a smaller stand.' };
    if (ppi < 75) return { level: 'soft', text: ' is about ' + ppi + ' pixels per inch at this size. It looks fine from a few steps away but soft up close. 100 or more is best.' };
    return null;
  }

  function updateArtUi() {
    var c = cfg();
    var two = c.sides === 2, backDiff = two && S.backMode === 'different';
    if (!two && S.face === 'back') { S.face = 'front'; S.back = false; }
    var a = editingArt();
    $('[data-abb-art-tabs]').hidden = !two;
    $$('[data-abb-face]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-face') === S.face ? 'true' : 'false'); });
    var sameBack = S.face === 'back' && !backDiff;
    $('[data-abb-drop]').hidden = sameBack;
    var upl = $('[data-abb-upload-label]'); if (upl) upl.textContent = S.face === 'back' ? 'Upload art for the back' : 'Upload artwork';
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var msg = '', level = '';
    if (sameBack) { empty.hidden = false; empty.textContent = 'The back shows the same art as the front.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
    else if (a && a.noPreview) { empty.hidden = true; msg = noPreviewText(a); level = 'soft'; }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the banner will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = S.face === 'back' ? 'No art for the back yet. Upload it above.' : 'No artwork yet. Upload yours above.'; }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var g = geom(a, c.Wi, c.Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
      $('[data-abb-bg]').value = a.bg;
    }
    // image resolution on every printed side; the worse one is shown, in the footer, where it is always in view
    var rf = resIssue(ART.front, c), rb = backDiff ? resIssue(ART.back, c) : null;
    var worst = rf && rb ? (rb.level === 'bad' && rf.level !== 'bad' ? 'back' : 'front') : (rf ? 'front' : (rb ? 'back' : ''));
    if (worst) {
      var r = worst === 'back' ? rb : rf;
      msg = (backDiff ? (worst === 'back' ? 'The image for the back' : 'The image for the front') : 'This image') + r.text; level = r.level;
    }
    [$('[data-abb-warn]'), $('[data-abb-res-warn]')].forEach(function (el) {
      if (!el) return;
      el.hidden = !msg; el.textContent = msg;
      if (msg && level) el.setAttribute('data-level', level); else el.removeAttribute('data-level');
    });
  }

  // ---------- render ----------
  function specLines(c) {
    var out = [['Stand', standLabel(c)], ['Size', sizeLabel(c)], ['Sides', sidesLabel(c)]];
    var mn = matLabel(c); if (mn) out.push(['Material', mn]);
    out.push(['Order', orderLabel(c)], ['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)]);
    return out;
  }

  function sidesNote(c) {
    return c.sides === 2 ? 'Printed on the front and the back. Use the same art on both sides, or give the back its own.'
      : 'Printed on the front.';
  }
  // small stand icons for the type cards (24 x 40)
  var SIL = {
    'retractable': '<rect x="6" y="3" width="12" height="29" rx="1" fill="currentColor" opacity=".85"/><rect x="4" y="32" width="16" height="4" rx="1.5" fill="currentColor"/><path d="M5 38h3M16 38h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    'tabletop': '<rect x="7" y="12" width="10" height="17" rx="1" fill="currentColor" opacity=".85"/><rect x="5.5" y="29" width="13" height="3" rx="1.2" fill="currentColor"/><path d="M2 34h20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    'x-stand': '<rect x="6" y="4" width="12" height="26" fill="currentColor" opacity=".85"/><path d="M6 4l12 26M18 4L6 30M12 17l-6 21M12 17l6 21" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>',
    'fabric': '<rect x="3" y="4" width="18" height="29" rx="4" fill="currentColor" opacity=".85"/><path d="M6 33v4M18 33v4M3 37h6M15 37h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>'
  };
  function famIcon(id) {
    return '<svg class="abb-opt__sil" viewBox="0 0 24 40" width="22" height="36" aria-hidden="true" focusable="false">' + (SIL[id] || SIL.retractable) + '</svg>';
  }

  function render() {
    var c = cfg();
    var p = price(c);
    var shown = standsShown();

    // 1. stand type: one card per type with its icon and its lowest price
    fill($('[data-abb-shapes]'), famsShown().map(function (f) {
      var lo = groupFrom(f.id);
      var html = famIcon(f.id) + '<span class="abb-opt__name">' + esc(f.name) + '</span><span class="abb-opt__price">' + (lo > 0 ? 'from ' + money(lo / 100) : 'Call us') + '</span>';
      return optBtn({ on: f.id === c.fam.id, html: html, data: ['shape', f.id], pick: function () { pickFamily(f.id); } });
    }));

    // 2. size: one card per model and size of that type, priced with the chosen order type
    var bases = [];
    shown.forEach(function (k) { if (groupOf(ST[k].fam) === c.fam.id && bases.indexOf(baseOf(k)) < 0) bases.push(baseOf(k)); });
    fill($('[data-abb-sizes]'), bases.map(function (b) {
      var ks = sideKeys(b), k0 = ks.filter(function (k) { return facesOf(k) === c.sides; })[0] || ks[0];
      var cents = fromCents(k0, c.order) || fromCents(k0), many = ks.length > 1 || matsFor(k0, c.order).length > 1;
      var html = '<span class="abb-opt__name">' + esc(sizeName(k0)) + '</span><span class="abb-opt__sub">' + esc(sizeSub(k0)) + '</span><span class="abb-opt__price">' + (cents > 0 ? (many ? 'from ' : '') + money(cents / 100) : 'Call us') + '</span>';
      return optBtn({ on: b === c.base, html: html, data: ['stand', k0], disabled: !(cents > 0), pick: function () { pickSize(k0); } });
    }));

    // 3. sides: 1 or 2 printed sides where the stand is made both ways; a 2-sided stand chooses what goes on the back
    var sk = sideKeys(c.key), has1 = sk.some(function (k) { return facesOf(k) === 1; }), has2 = sk.some(function (k) { return facesOf(k) === 2; });
    var sWrap = $('[data-abb-sides-wrap]'); if (sWrap) sWrap.hidden = !has2;
    var sBox = $('[data-abb-sides]');
    if (sBox) sBox.hidden = !(has1 && has2);
    fill(sBox, has1 && has2 ? [1, 2].map(function (n) {
      var k = sk.filter(function (x) { return facesOf(x) === n; })[0], cents = fromCents(k, c.order) || fromCents(k);
      return optBtn({ on: c.sides === n, data: ['sides', n], disabled: !(cents > 0), html: '<span class="abb-opt__name">' + (n === 2 ? '2 sides' : '1 side') + '</span><span class="abb-opt__sub">' + (n === 2 ? 'Printed front and back' : 'Printed on the front') + '</span><span class="abb-opt__price">' + (cents > 0 ? money(cents / 100) : 'Call us') + '</span>', pick: function () { pickSides(n); } });
    }) : []);
    setText('[data-abb-sides-note]', sidesNote(c));
    var bmWrap = $('[data-abb-backmode-wrap]'); if (bmWrap) bmWrap.hidden = c.sides !== 2;
    fill($('[data-abb-backmodes]'), [
      optBtn({ chip: true, on: S.backMode !== 'different', data: ['backmode', 'same'], label: 'Same as front', pick: function () { pickBackMode('same'); } }),
      optBtn({ chip: true, on: S.backMode === 'different', data: ['backmode', 'different'], label: 'Different back', pick: function () { pickBackMode('different'); } })
    ]);

    // 4. material: only when the stand comes in more than one
    var mWrap = $('[data-abb-bag-wrap]'); if (mWrap) mWrap.hidden = c.mats.length < 2 && !matLabel(c);
    fill($('[data-abb-bags]'), c.mats.length > 1 ? c.mats.map(function (m) {
      var v = variantFor(c.key, c.order, m), sub = matSub(c.key, m);
      var html = '<span class="abb-opt__name">' + esc(matName(c.key, m) || 'Standard') + '</span>' + (sub ? '<span class="abb-opt__sub">' + esc(sub) + '</span>' : '') + '<span class="abb-opt__price">' + (v.cents > 0 ? money(v.cents / 100) : 'Call us') + '</span>';
      return optBtn({ on: m === c.mat, html: html, data: ['mat', m], disabled: (LIVE && !v.available) || !(v.cents > 0), pick: function () { pickMat(m); } });
    }) : (matLabel(c) ? [optBtn({ on: true, html: '<span class="abb-opt__name">' + esc(matLabel(c)) + '</span>', data: ['mat', c.mat], pick: function () {} })] : []));
    setText('[data-abb-bag-note]', c.mats.length > 1 ? 'Price per ' + qtyNoun(c, 1) + ' in ' + (matLabel(c) || 'this material') + '.' : 'This stand comes in one material.');

    // 5. order: the stand with its graphic, or the graphic only (where we sell it), each with its price
    fill($('[data-abb-kits]'), c.orders.map(function (o) {
      var cents = fromCents(c.key, o.id), v = variantFor(c.key, o.id, c.mat), each = v.cents > 0 ? v.cents : cents;
      var html = '<span class="abb-opt__name">' + esc(o.name) + '</span><span class="abb-opt__sub">' + esc(o.sub) + '</span><span class="abb-opt__price">' + (each > 0 ? money(each / 100) : 'Call us') + '</span>';
      return optBtn({ on: o.id === c.order, html: html, data: ['order', o.id], disabled: !(each > 0), pick: function () { pickOrder(o.id); } });
    }));
    setText('[data-abb-kit-note]', c.order === 'GO' ? 'Graphic only: a new printed graphic for a ' + sizeName(c.key) + ' ' + c.fam.short + ' you already have. Check that your stand takes this graphic size.' : 'The stand and your printed graphic, ' + money(p.each - (p.led || 0)) + ' each.');

    // 6. quantity: 1 to 100
    var qIn = $('[data-abb-qty]'); if (qIn && document.activeElement !== qIn) qIn.value = String(c.qty);
    var qm = $('[data-abb-qty-minus]'), qp = $('[data-abb-qty-plus]'); if (qm) qm.disabled = c.qty <= 1; if (qp) qp.disabled = c.qty >= MAX_QTY;
    setText('[data-abb-qty-unit]', qtyNoun(c, 2));
    setText('[data-abb-qty-note]', c.qty > 1 ? qtyLabel(c.qty, c) + ' at ' + money(p.each) + ' each: ' + money(p.charged) + '. All ' + qtyNoun(c, 2) + ' have the same art.' : money(p.each) + ' per ' + qtyNoun(c, 1) + '. All ' + qtyNoun(c, 2) + ' in an order have the same art.');

    // 6b. LED light: only for stands sold with LED, with the stand (not graphic only)
    (function () {
      var lo = c.ledOpt, wrap = $('[data-abb-led-wrap]') || document.querySelector('[data-abb-led-wrap]');
      if (!wrap && lo) {
        var kit = $('[data-abb-kits]'), krow = kit && kit.closest('.abx-row'), kst = kit && kit.closest('.abb-step');
        if (krow && krow.parentNode) {
          // app layout (ardor-stand-app.js moves the steps into rows): a row like Material, right after the Order row
          wrap = document.createElement('div');
          wrap.className = 'abx-row';
          wrap.setAttribute('data-abx-row', 'led');
          wrap.setAttribute('data-abb-led-wrap', '');
          wrap.innerHTML = '<span class="abx-row__label">LED light</span><div class="abb-opts abb-opts--two" data-abb-led></div><p class="abb-help" data-abb-led-note></p>';
          krow.parentNode.insertBefore(wrap, krow.nextSibling);
        } else if (kst && kst.parentNode) {
          wrap = document.createElement('section');
          wrap.className = 'abb-step';
          wrap.setAttribute('data-abb-step', 'led');
          wrap.setAttribute('data-abb-led-wrap', '');
          wrap.innerHTML = '<h2 class="abb-step__title"><span class="abb-step__num"></span>LED light</h2><div class="abb-opts abb-opts--two" data-abb-led></div><p class="abb-help" data-abb-led-note></p>';
          kst.parentNode.insertBefore(wrap, kst.nextSibling);
        }
      }
      if (!wrap) return;
      wrap.hidden = !lo;
      if (!lo) return;
      fill($('[data-abb-led]', wrap), [
        optBtn({ on: !c.led, data: ['led', '0'], html: '<span class="abb-opt__name">No</span><span class="abb-opt__sub">No light</span>', pick: function () { set({ led: false }); } }),
        optBtn({ on: !!c.led, data: ['led', '1'], html: '<span class="abb-opt__name">' + esc(lo.name) + '</span><span class="abb-opt__sub">Added to your cart with the stand</span><span class="abb-opt__price">+' + money(lo.cents / 100) + '</span>', pick: function () { set({ led: true }); } })
      ]);
      var note = $('[data-abb-led-note]', wrap);
      if (note) note.textContent = c.led ? lo.name + ': +' + money(lo.cents / 100) + ' per ' + qtyNoun(c, 1) + ', included in the total.' : '';
    })();

    // 7. delivery: free shipping or free pickup
    fill($('[data-abb-delivery]'), [
      optBtn({ on: c.delivery === 'ship', data: ['delivery', 'ship'], html: '<span class="abb-opt__name">Ship it to me (free)</span><span class="abb-opt__sub">Free shipping to your address</span>', pick: function () { set({ delivery: 'ship' }); } }),
      optBtn({ on: c.delivery === 'pickup', data: ['delivery', 'pickup'], html: '<span class="abb-opt__name">Pick up at our Snohomish shop (free)</span><span class="abb-opt__sub">' + esc(PICKUP) + '</span>', pick: function () { set({ delivery: 'pickup' }); } })
    ]);

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // price box: the total, then quantity x price
    setText('[data-abb-total]', money(p.charged));
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.qty < 2;
    eachEl.textContent = qtyLabel(c.qty, c) + ' x ' + money(p.each);
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }
    var dl = c.delivery === 'pickup' ? 'Free pickup at our Snohomish shop' : 'Free shipping';
    setText('[data-abb-free]', dl + '. You approve your proof before checkout.');
    $$('[data-abb-dnote]').forEach(function (el) { el.textContent = dl; });

    // summary chips, the tip on the stage and the 3D tools
    setText('[data-abb-chip-size]', sizeChip(c));
    setText('[data-abb-chip-mat]', c.sides === 2 ? '2 sides' : '1 side');
    setText('[data-abb-chip-sides]', c.order === 'GO' ? qtyLabel(c.qty, c) + ' only (no stand)' : qtyLabel(c.qty, c) + ' with graphic');
    setText('[data-abb-tip]', 'Keep text and logos inside the red line.' + (c.geo.hidden.length ? ' Grey areas are hidden in the stand.' : (c.geo.pockets.length ? ' Keep text out of the pole pockets.' : '')));
    setText('[data-abb-flip]', S.back ? 'Show front' : 'Show back');
    root.setAttribute('data-abb-stand', c.key);

    updateArtUi();
    drawLayout();
    sync3d();
  }

  // ---------- 3D viewer (window.ArdorStand3D, three.js). Everything else works without it. ----------
  // ---------- 3D viewer (window.ArdorStand3D, three.js). Everything else works without it. ----------
  var faceCv = { front: null, back: null }, faceSent = { front: '', back: '' }, engSent = '', syncQueued = false;
  // one face for the 3D view: the whole template page as printed (the 3D stand shows its visible part)
  function paintFaceCanvas(c, face) {
    var Wi = c.Wi, Hi = c.Hi, k = Math.min(40, 2048 / Math.max(Wi, Hi));
    var w = Math.max(2, Math.round(Wi * k)), h = Math.max(2, Math.round(Hi * k));
    var cv = faceCv[face] || (faceCv[face] = document.createElement('canvas'));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    var ctx = cv.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, w, h);
    ctx.setTransform(w / Wi, 0, 0, h / Hi, 0, 0);
    drawFlat(ctx, c, Wi, Hi, face === 'back' ? 'back-flat' : 'front', false);
    return cv;
  }
  function sendFace(face, cv) {
    var key = cv ? cv.width + 'x' + cv.height + '|' + engSent : 'none';
    if (faceSent[face] === key) return;
    faceSent[face] = key;
    eng.setFace(face, cv);
  }
  // the 3D stand gets the stand's template (page, visible area, hidden zones), its sides, hardware and order type, then
  // the printed page of each face (the back only on 2-sided stands: the front art again, or the back's own art)
  function sync3d() {
    if (!eng) return;
    var c = cfg();
    try {
      var g = faceGeo(c, 'front');
      var key = [c.key, c.sides, c.order].join('|');
      if (key !== engSent) {
        engSent = key;
        eng.set({ key: c.key, family: c.famId, tpl: { w: g.W, h: g.H }, visible: [g.vis.x, g.vis.y, g.vis.w, g.vis.h],
          hidden: g.hidden.map(function (z) { return { rect: [z.x, z.y, z.w, z.h], why: z.why }; }), bleed: g.bleed, grommets: g.grommets,
          faces: c.sides, hardware: c.st.hardware || {}, order: c.order, cut: g.cutPoly ? g.cut : null, pockets: g.pockets.map(function (z) { return { rect: [z.x, z.y, z.w, z.h] }; }) });
      }
      sendFace('front', paintFaceCanvas(c, 'front'));
      sendFace('back', c.sides === 2 ? paintFaceCanvas(c, 'back') : null);
      eng.refresh();
    } catch (e) {}
  }
  function sync3dSoon() {
    if (!eng || syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync3d(); });
  }
  function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } }
  function startEngine() {
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorStand3D && host) ? window.ArdorStand3D.create(host, { background: '#ffffff' }) : null; } catch (e) { eng = null; }
    if (!eng) { if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
  }

  // ---------- proof sheet and print files ----------
  function proofCanvas(face, overlayOnly) {
    var c = cfg(), Wi = c.Wi, Hi = c.Hi;
    var long = 1800, cw, ch;
    if (Wi >= Hi) { cw = long; ch = Math.max(60, Math.round(long * Hi / Wi)); } else { ch = long; cw = Math.max(60, Math.round(long * Wi / Hi)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / Wi, 0, 0, ch / Hi, 0, 0);
    var fk = face === 'back' ? 'back-flat' : 'front';
    var drewArt = overlayOnly || paintFace(ctx, Wi, Hi, fk);
    if (overlayOnly && hasLayers(layerFace(fk))) window.ArdorStandLayers.paint(ctx, Wi, Hi, layerFace(fk));
    if (!drewArt) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      var G = faceGeo(c, fk);
      ctx.save(); ctx.translate(G.bx + G.bw / 2, G.by + G.bh / 2); if (G.bh > G.bw * 1.6) ctx.rotate(-Math.PI / 2);
      ctx.fillStyle = '#5E5A55'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Math.min(G.bw, G.bh) * 0.16, Math.max(G.bw, G.bh) * 0.05) + 'px Arial, sans-serif';
      ctx.fillText('Your artwork', 0, 0); ctx.restore();
    }
    var u = Math.max(Wi, Hi) / long; // inches per canvas pixel
    drawGuides(ctx, c, Wi, Hi, fk, u * 2.4);
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var r = a.rot || 0, ia = rot90(a) ? nh / nw : nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi, rot: r };
      var fw0 = Math.min(Wi, Hi * ia), fh0 = fw0 / ia;
      return { x: (Wi - fw0) / 2, y: (Hi - fh0) / 2, w: fw0, h: fh0, rot: r, note: 'The uploaded PDF is a different shape than the stand template, so it was placed to fit, centered, with white around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h, rot: r };
  }

  function loadPdfTool() {
    if (window.ArdorStandPDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorStandPDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, c) {
    if (!a || !a.img) return '';
    var turn = a.rot === 90 ? ', turned 90 degrees right' : (a.rot === 270 ? ', turned 90 degrees left' : (a.rot === 180 ? ', turned upside down' : ''));
    if (a.mode === 'fill') return (a.tpl ? 'Template file, placed edge to edge (bleed and hidden areas included)' : 'Fill the template (edges may crop)') + turn;
    if (a.mode === 'fit') return 'Fit whole image' + turn + ', background ' + a.bg;
    var g = geom(a, c.Wi, c.Hi);
    return 'Custom: art ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from the print page top-left' + turn + ', background ' + a.bg;
  }
  function artworkLabel() { return ART.front ? ART.front.name : (hasLayers('front') ? 'Text and clipart added in the builder' : 'None'); }
  function backLabel() { return S.backMode === 'different' ? (ART.back ? ART.back.name : (hasLayers('back') ? 'Text and clipart added in the builder' : 'Different art')) : 'Same as front'; }

  // the proof legend: what the guides on this stand's template mean
  function legendText(c) {
    var g = c.geo, kinds = [];
    g.hidden.forEach(function (z) { var t = String(z.why || 'hidden').toLowerCase(); if (kinds.indexOf(t) < 0) kinds.push(t); });
    var out = kinds.length ? 'Grey areas: hidden in the stand (' + kinds.join(', ') + '). ' : '';
    if (g.pockets.length) out += 'Shaded bands: pole pockets, keep text out of them. ';
    if (g.cutPoly) out += 'Outside the outline is cut off. ';
    return out + 'Black line: the visible area. Dashed red line: keep text and logos inside it.';
  }
  function proofSpecs(c) {
    var out = [['Stand', standLabel(c)], ['Size', sizeLabel(c)], ['Sides', sidesLabel(c)], ['Order', orderLabel(c)]];
    var mn = matLabel(c); if (mn) out.push(['Material', mn]);
    out.push(['Quantity', qtyLabel(c.qty, c)], ['Delivery', deliveryLabel(c)]);
    out.push(['Artwork', artworkLabel()]);
    var pl = placementText(ART.front, c); if (pl) out.push(['Placement', pl]);
    if (c.sides === 2) out.push(['Back', backLabel()]);
    if (c.sides === 2 && S.backMode === 'different') { var pb = placementText(ART.back, c); if (pb) out.push(['Back placement', pb]); }
    out.push(['Print size', tplTxt(c) + ' template page per printed side (visible area ' + visTxt(c.geo) + ')']);
    var added = layerSummary(c); if (added) out.push(['Added in the builder', added]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
function proofViews(c) {
var out = [];
try { sync3d(); } catch (e) {}
if (!eng || typeof eng.snapshot !== 'function') return out;
[['home', 'From the front'], (c.sides === 2 ? ['back', 'From the back'] : ['side', 'From the side'])].forEach(function (v) {
try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
});
return out;
}
function proofSheet(P, c, mode, o) {
var PS = window.ArdorProofSheet;
if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
o.noun = qtyNoun(c, c.qty) === 'graphic' || qtyNoun(c, c.qty) === 'graphics' ? (c.qty > 1 ? 'banner stand graphics' : 'banner stand graphic') : (c.qty > 1 ? 'banner stands' : 'banner stand'); o.preview = mode === 'preview'; o.views = proofViews(c);
return PS.build(o).catch(function () { return P.buildProof(o); });
}
  function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorStandPDF, Wi = c.Wi, Hi = c.Hi;
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var out = { notes: [], proof: null, front: null, back: null };
      var dimW = fmt(Wi) + ' in', dimH = fmt(Hi) + ' in';
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (!a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      // turned PDF/AI art shows on the proof from its drawn preview (the shared proof sheet places vector art unturned)
      var mkProofFace = function (label, faceKey, a) {
        var va = a && !a.rot ? vectorArt(a) : null;
        return { label: label, canvas: proofCanvas(faceKey, !!va), fallback: va ? proofCanvas(faceKey, false) : null, wIn: Wi, hIn: Hi, wLabel: dimW, hLabel: dimH, underlay: va ? { art: va, bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } } : null };
      };
      var faces = [mkProofFace(frontLabel(c), 'front', ART.front)];
      if (backDiff) faces.push(mkProofFace('Back (as seen from the back)', 'back', ART.back));
      var date = (approval && approval.when) || stampLabel(new Date());
      var go = c.order === 'GO';
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, {
          logo: logo, title: 'Ardor Banner Stand Proof', panelTitle: go ? (c.qty > 1 ? 'Your graphics' : 'Your graphic') : (c.qty > 1 ? 'Your banner stands' : 'Your banner stand'), sideBySide: true,
          legend: legendText(c) + ' Print page ' + fmt(Wi) + ' x ' + fmt(Hi) + ' in (width x height), bleed included.',
          approval: approval || null, date: date, faces: faces, specs: proofSpecs(c),
          footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
        });
      }).catch(function () { return null; });
      var arts = [ART.front]; if (backDiff) arts.push(ART.back);
      var printable = function (a, i) { return a ? (a.kind === 'image' || !!vectorArt(a)) : hasLayers(i ? 'back' : 'front'); };
      var printP = Promise.resolve();
      // print files: one PDF per printed face that has its own art, the size of the template page
      if (proofMode === 'preview') { /* PDF button: the proof only, no print files */ } else if (!arts.every(printable)) out.notes.push('Print files were not made automatically for this file type. Use the original artwork file.');
      else {
        if (arts.some(function (a) { return a && a.src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        // template page size, art to the page edge (bleed and hidden zones included), no guides. buildPrint takes feet.
        var mkJob = function (a) {
          if (a.rotated && out.notes.indexOf(ROT_NOTE) < 0) out.notes.push(ROT_NOTE);
          return { title: 'Ardor Banner Stand Print File', stamp: date, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125, faces: [{ art: a.kind === 'image' ? { file: a.printFile || a.file, name: a.name, kind: 'image' } : vectorArt(a), bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } }] };
        };
        var keep = function (r) { r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); }); return r.blob; };
        printP = layerJob(mkJob, ART.front, 'front', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r) {
          out.front = keep(r);
          if (!backDiff) return null;
          return layerJob(mkJob, ART.back, 'back', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r2) { out.back = keep(r2); });
        }).catch(function (e) { out.front = null; out.back = null; out.notes.push('Print files could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; return out; });
    });
  }

  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    // disabled Oct 18 2026 – duplicate of Shopify Google & YouTube / Facebook app event (add_to_cart / AddToCart). The generate_lead / Lead branch fired on the "Go to the quote form" link click, not on a sent lead; the lead itself is the HubSpot form submit, which GTM already sends as generate_lead + the Google Ads quote conversion. The dataLayer push above stays. Undo: remove "// " from the next 2 lines.
    // try { if (window.gtag) window.gtag('event', name === 'ardor_stand_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    // try { if (window.fbq) window.fbq('track', name === 'ardor_stand_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var faces = [[frontLabel(c), 'front', ART.front]];
      if (backDiff) faces.push(['Back', 'back', ART.back]);
      faces.forEach(function (f) {
        var cv = proofCanvas(f[1], false);
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[0] + ' of your banner stand proof'; im.src = cv.toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption');
        var isFile = f[2] && f[2].kind !== 'image';
        cap.textContent = f[0] + ': ' + sizeLabel(c) + (isFile ? '. We print from your original file (' + f[2].name + ').' : '');
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    var PL = window.ArdorProofLater; if (PL && PL.on() && !(window.ArdorArtLink && window.ArdorArtLink.emailChosen(root))) { e.preventDefault(); var plr = PL.approve(root); if (plr) closeApproval(plr); return; } // DSN Oct 25 2026: one approval box now; name + typed signature in the cart, email + phone at checkout
    var AL = window.ArdorArtLink; if (AL && AL.emailChosen(root)) { e.preventDefault(); var pe = AL.proofEmail(root); if (pe) closeApproval({ emailProof: true, email: pe }); return; } // ART0 Oct 19 2026: "Email me the proof to approve"
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  // One line: the stand variant (stand, order type and material), quantity = the number of stands (or graphics),
  // everything else as line item properties.
  function setupMsg() { return 'Online ordering for this banner stand is being set up. Call ' + PHONE + ' or request a quote.'; }

  function addToCart() {
    showErr('');
    var c = cfg(); var p = price(c);
    if (!p.vid || !c.v.available) { showErr(setupMsg()); return; }
    var artLink = window.ArdorArtLink ? window.ArdorArtLink.link(root, ART.front && ART.front.file) : null; // ART0 Oct 19 2026: artwork by link
    if (!ART.front && !hasLayers('front') && !artLink) {
      if (S.face !== 'front') { S.face = 'front'; S.back = false; render(); }
      showErr('Upload your artwork first.');
      return;
    }
    var backDiff = c.sides === 2 && S.backMode === 'different';
    if (backDiff && !ART.back && !hasLayers('back')) {
      if (S.face !== 'back') { S.face = 'back'; S.back = true; render(); }
      showErr('Upload the art for the back, or choose "Same as front".');
      return;
    }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false, proofEmail = ''; // ART0: proofEmail
    var waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () {
      emailProof = needsEmailProof() || !!(artLink && !artLink.loaded); // ART0: a link we couldn't open = emailed proof
      return emailProof ? null : openApproval(c);
    }).then(function (ap) {
      if (ap && ap.emailProof) { proofEmail = ap.email; emailProof = true; ap = null; } // ART0: "Email me the proof to approve"
      approval = ap;
      btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
      return buildFiles(c, approval).then(function (files) { return fitUpload(c, files, approval); }); // Oct 12: stay under the cart's 20 MB upload limit
    }).then(function (files) {
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', String(c.qty));
      fd.append('properties[Stand]', standLabel(c));
      fd.append('properties[Size]', sizeLabel(c));
      fd.append('properties[Sides]', sidesLabel(c));
      fd.append('properties[Order]', orderLabel(c));
      if (c.led) fd.append('properties[LED Light]', c.led.name + ' (its own cart line)');
      var mn = matLabel(c); if (mn) fd.append('properties[Material]', mn);
      fd.append('properties[Quantity]', qtyLabel(c.qty, c));
      fd.append('properties[Delivery]', c.delivery === 'pickup' ? 'Pick up at our Snohomish shop (free)' : 'Ship to me (free)');
      fd.append('properties[Artwork]', artworkLabel());
      if (c.sides === 2) fd.append('properties[Back]', backLabel());
      var notes = ($('[data-abb-notes]').value || '').trim();
      if (notes) fd.append('properties[Notes]', notes);
      fd.append('properties[Designed in]', 'Ardor Banner Stand Designer');
        if (artLink) fd.append('properties[Artwork link]', artLink.url); // ART0
        if (proofEmail || (artLink && !artLink.loaded)) fd.append('properties[Proof approval]', 'Email - pending'); // ART0
        if (proofEmail) fd.append('properties[Proof email]', proofEmail); // ART0
      var pl = placementText(ART.front, c); if (pl) fd.append('properties[_Art placement]', pl);
      if (backDiff) { var pb = placementText(ART.back, c); if (pb) fd.append('properties[_Back placement]', pb); }
      var added = layerSummary(c); if (added) fd.append('properties[_Added in the builder]', added);
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
      var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
      var MAXPDF = 25 * 1024 * 1024;
      if (files.proof && approval) fd.append('properties[Ardor Banner Stand Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Banner Stand Proof'));
      else if (files.proof) fd.append('properties[_Ardor Banner Stand Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor Banner Stand Unsigned Proof'));
      if (!approval) fd.append('properties[Proof]', artLink && !artLink.loaded ? 'Ardor will build the proof from your link and email it to you to approve' : 'We\'ll email you a proof to approve before printing'); // ART0
      if (approval) {
        if (!approval.later) fd.append('properties[Approved by]', approval.name); // DSN: the name comes with the cart signature
        fd.append('properties[Approved on]', approval.when);
        if (!approval.later) fd.append('properties[_Approver email]', approval.email); // DSN: email + phone come from checkout
        if (!approval.later) fd.append('properties[_Approver phone]', approval.phone); else { fd.append('properties[Proof approval]', approval.later); fd.append('properties[_Proof sign]', 'cart'); } // DSN
      }
      var tooBig = false;
      [['front', 'Front'], ['back', 'Back']].forEach(function (k) {
        var bl = files[k[0]]; if (!bl) return;
        if (bl.size <= MAXPDF) fd.append('properties[_Ardor Banner Stand Print File ' + k[1] + ' - ' + labelStamp + ']', pdfFile(bl, 'Ardor Banner Stand Print File ' + k[1]));
        else tooBig = true;
      });
      if (tooBig) files.notes.push('A print file was over 25 MB, so it was not attached. Use the original artwork file.');
      var g = c.geo, tname = (g.tplName || '').replace(/\.pdf$/i, '').replace(/^[\s_-]+|[\s_-]+$/g, '');
      var pnote = ['Stand ' + c.key + ': ' + standLabel(c) + ', ' + sizeName(c.key) + ' (visible graphic ' + visTxt(g) + '). Template' + (tname ? ' ' + tname : '') + ': page ' + tplTxt(c) + ', visible area at ' + fmt(g.vis.x) + ', ' + fmt(g.vis.y) + ' in from the page top-left' + (g.hidden.length ? '; hidden: ' + g.hidden.map(function (z) { return (z.why || 'hidden') + ' ' + fmt(z.w) + ' x ' + fmt(z.h) + ' in'; }).join(', ') : '') + '. Order: ' + (c.order === 'GO' ? 'graphic only (no stand)' : 'stand + graphic') + '. ' + (mn ? 'Material: ' + mn + '. ' : '') + 'Quantity: ' + qtyLabel(c.qty, c) + '. Delivery: ' + (c.delivery === 'pickup' ? 'pickup in Snohomish' : 'ship to the customer (blind ship)') + '.'];
      if (c.sides === 2) pnote.push(backDiff ? 'Different art on the back: use the front file for the front and the back file for the back (the back as seen from behind the stand).' : 'Same art on both sides: use the front file for both sides.');
      if (files.front) pnote.push('Print file' + (files.back ? 's are' : ' is') + ' the template page for one side, ' + tplTxt(c) + ', art to the page edge (bleed and hidden zones included), no guides, 100% scale.');
      if (g.placeholder) pnote.push('Check the template: this stand used provisional template geometry.');
      files.notes.forEach(function (n) { pnote.push(n); });
      fd.append('properties[_Print file note]', pnote.join(' '));
      var skipArt = files.skipArt || {};
      if (ART.front && !skipArt.front) fd.append('properties[Ardor Banner Stand Artwork - ' + labelStamp + ']', ART.front.file, 'Ardor Banner Stand Artwork ' + fileStamp + ext(ART.front.name));
      if (backDiff && ART.back && !skipArt.back) fd.append('properties[Ardor Banner Stand Artwork Back - ' + labelStamp + ']', ART.back.file, 'Ardor Banner Stand Artwork Back ' + fileStamp + ext(ART.back.name));
      if (files.needEmail) fd.append('properties[Artwork file]', 'Too large to upload with the order. Please email it to info@ardorprinting.com.');
      fd.append('properties[_spec]', JSON.stringify({ v: p.vid, sku: c.v.sku || '', stand: c.key, s: c.sides, o: c.order, m: c.mat, b: c.sides === 2 ? S.backMode : '', led: c.led ? c.led.sku : '', n: c.qty, each: p.each, total: p.charged, del: c.delivery, page: [c.Wi, c.Hi], vis: [g.vis.x, g.vis.y, g.vis.w, g.vis.h] }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          if (xhr.status === 413) msg = 'Your files are too big to upload with the order. Please try a smaller file, or request a quote.';
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () { return addLed(c); }).then(function () {
      track('ardor_stand_added_to_cart', { value: p.charged, stand: c.key, sides: c.sides, order: c.order, material: c.mat, quantity: c.qty });
      toast(emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.');
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) {
      if (err && err.cancel) { done(); return; }
      showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done();
    });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c).map(function (l) { return l[0] + ': ' + l[1]; });
    if (ART.front) lines.push('Artwork: ' + ART.front.name + ' (I will send the file)');
    var pl = placementText(ART.front, c); if (pl) lines.push('Placement: ' + pl);
    if (c.sides === 2) lines.push('Back: ' + (S.backMode === 'different' ? (ART.back ? ART.back.name : 'different art') : 'same as front'));
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    lines.push('Online price shown: ' + money(p.charged) + ' (' + qtyLabel(c.qty, c) + ' x ' + money(p.each) + ')');
    return lines.join('\n');
  }

  function openQuote(want) {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText() + (typeof want === 'number' && want > MAX_QTY ? '\nQuantity wanted: ' + want : '');
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'Banner stands from the Ardor Banner Stand Designer\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    // "Need more than 100, another size or a custom shape? Request a quote"
    on('[data-abb-quote-link]', 'click', openQuote);
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, uploadFace(f)); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, uploadFace(f)); });
    $$('[data-abb-face]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.face = b.getAttribute('data-abb-face'); S.back = S.face === 'back';
        render(); view3d(S.back ? 'back' : 'front');
      });
    });
    
    
    on('[data-abb-flip]', 'click', function () { S.back = !S.back; render(); view3d(S.back ? 'back' : 'front'); });
    on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { S.back = false; render(); view3d('home'); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_stand_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindStand();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // quantity box, the "more than 100" quote link and the PDF proof button on the tool rail
  function bindStand() {
    var q = $('[data-abb-qty]');
    if (q) {
      q.addEventListener('input', function () { var v = parseInt(q.value, 10); if (v >= 1) setQty(Math.min(MAX_QTY, v)); if (v > MAX_QTY) { q.value = String(MAX_QTY); openQuote(v); } });
      q.addEventListener('change', function () { setQty(q.value); });
      q.addEventListener('blur', function () { render(); });
    }
    on('[data-abb-qty-minus]', 'click', function () { setQty(cfg().qty - 1); });
    on('[data-abb-qty-plus]', 'click', function () { setQty(cfg().qty + 1); });
  }
  // the shared proof sheet (assets/ardor-proofsheet.js) puts its PDF button on the rail for the builders it knows;
  // the banner stand designer adds the same button itself and opens the same preview window
  function mountPdf(tries) {
    var PS = window.ArdorProofSheet, B = window.ArdorStandBuilder, rail = $('.abx-rail');
    if (!PS || typeof PS.preview !== 'function' || !rail || !B || !B.proof) { if ((tries || 0) < 40) setTimeout(function () { mountPdf((tries || 0) + 1); }, 250); return; }
    if (B.proof._btn || $('[data-abb-pdf]', rail)) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'abx-tool'; btn.setAttribute('data-abb-pdf', ''); btn.title = 'Download a PDF proof preview';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 4v11m0 0 4.5-4.5M12 15l-4.5-4.5M4 19.5h16"/></svg><span>PDF</span>';
    var qb = $('[data-abx-quote]', rail);
    if (qb && qb.nextSibling) rail.insertBefore(btn, qb.nextSibling); else rail.appendChild(btn);
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); PS.preview(B.proof); });
    B.proof._btn = btn;
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    startEngine();
    window.ArdorStandBuilder = {
      state: S, specs: SPECS, stands: standsShown, live: function () { return LIVE; }, cfg: cfg, price: price, render: render, variantFor: variantFor, geo: faceGeo, viewer: function () { return eng; },
      proofCanvas: proofCanvas, files: function (approval) { return buildFiles(cfg(), approval || null); },
      pickStand: pickStand, pickFamily: pickFamily, pickSize: pickSize, pickSides: pickSides, pickOrder: pickOrder, pickMat: pickMat, pickBackMode: pickBackMode, setZoom: setZoom,
      faceCanvas: function (face) { return paintFaceCanvas(cfg(), face === 'back' ? 'back' : 'front'); },
      // names for the template download (assets/ardor-stand-tpl.js)
      tplInfo: function () { var c = cfg(); return { key: c.key, product: standLabel(c), size: sizeLabel(c), sizeName: sizeName(c.key), sides: c.sides, sidesText: sidesLabel(c), Wi: c.Wi, Hi: c.Hi }; },
      parseSku: parseSku, sku: function (key, order, mat) { return 'BS-' + key + '-' + order + (mat ? '-' + mat : ''); },
      layout: function () { return { zoom: lay.zoom, scale: lay.scale, ox: lay.ox, oy: lay.oy, cx: lay.cx, cy: lay.cy }; }
    };
    // used by ardor-stand-layers.js (text and clipart layers). Sizes are in inches (c.Wi x c.Hi).
    window.ArdorStandAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast,
      getArt: function (face) { return ART[face === 'back' ? 'back' : 'front']; },
      setArt: function (face, a) { ART[face === 'back' ? 'back' : 'front'] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      editFace: function () { return S.face === 'back' ? (S.backMode === 'different' ? 'back' : null) : 'front'; },
      artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? artFor(f) : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.Wi, Hi || c.Hi) : null; },
      // where the page sits on the 2D layout canvas (zoom and pan): z = css px per inch, ox / oy = page corner in css px
      layoutView: function () { return { z: lay.scale, ox: lay.ox, oy: lay.oy }; },
      // the visible area of a face (AI designs are fitted inside it, then extended over the whole page), and that area inside
      // the safe line (new text and logos go there)
      faceBox: function (face) { var g = faceGeo(cfg(), face === 'back' ? 'back-flat' : 'front'); return { x: g.vis.x, y: g.vis.y, w: g.vis.w, h: g.vis.h }; },
      pageBox: function () { var c = cfg(); return { x: 0, y: 0, w: c.Wi, h: c.Hi }; },
      safeBox: function () { var g = faceGeo(cfg(), S.face === 'back' ? 'back-flat' : 'front'), r = g.safeR; return { x: r.x, y: r.y, w: Math.max(1, r.w), h: Math.max(1, r.h) }; },
      pickStand: pickStand, standKey: function () { return cfg().key; }, pickBackMode: pickBackMode,
      standInfo: function (key) { var k = normKey(key); if (!k) return null; var g = geoFor(k, false); return { key: k, fam: ST[k].fam, group: groupOf(ST[k].fam), faces: facesOf(k), name: (ST[k].stand || '') + ', ' + sizeName(k), visible: { w: g.vis.w, h: g.vis.h }, page: { w: g.W, h: g.H } }; },
      standName: function () { var c = cfg(); return standLabel(c) + ', ' + sizeName(c.key); },
      stands: function () { return standsShown(); }
    };
    window.ArdorStandBuilder.proof = { noun: 'banner stands', file: 'Ardor Banner Stand Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
var c = cfg(), waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
} };
try { document.dispatchEvent(new CustomEvent('ardor:stand-api')); } catch (e) {}
    mountPdf(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
